import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete-esb';
import { NgxMaskModule } from 'ngx-mask';

import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { ThemesService } from '../../../../services/themes.service';
import { ProductEnum } from '../../../authentication/models/product.enum';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { FormControlNameExport } from '../../../directives/form-control-name-export.directive';
import { DisableAutofillDirective } from '../../../shared/directives/disable-autofill.directive';
import { SharedService } from '../../../shared/services/shared.service';
import { StatesService } from '../../../shared/services/states.service';
import { InviteSignupProcessService } from '../../services/invite-signup-process.service';

@Component({
  selector: 'app-invite-signup-process-address',
  templateUrl: './invite-signup-process-address.component.html',
  styleUrls: ['./invite-signup-process-address.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatError,
    MatButtonModule,
    GooglePlaceModule,
    DisableAutofillDirective,
    LocalisePipe,
    FormControlNameExport,
    NgxMaskModule,
  ],
})
export class InviteSignupProcessAddressComponent implements OnInit {
  public loading = false;
  public error = '';

  constructor(
    public statesService: StatesService,
    public themesService: ThemesService,
    public inviteSignupProcessService: InviteSignupProcessService,
    private sharedService: SharedService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    const user = this.authenticationService.getProfileState();
    if (!user.productIds.includes(ProductEnum.Payment)) {
      this.inviteSignupProcessService.nextStep();
      return;
    }
    if (user.state !== '') {
      this.inviteSignupProcessService.nextStep();
      return;
    }
  }

  public async next(): Promise<void> {
    if (this.inviteSignupProcessService.addressForm.invalid) {
      return;
    }

    this.loading = true;

    try {
      await this.inviteSignupProcessService.updateAddress().toPromise();
      this.inviteSignupProcessService.nextStep();
    } catch (e) {
      this.error = this.sharedService.getErrorText(e, true);
    }

    this.loading = false;
  }
}
